import { useEffect, useState } from 'react';
import axios from 'axios';

import Debouncer from '../../helpers/Debouncer';

const debouncer = new Debouncer();
const searchForForms = async (params = {}) => (
  debouncer.debounce(async () => {
    try {
      const {
        projectId,
        customerId,
        vendorId,
        cardId,
        equipmentId,
        searchTerm,
        startTime,
        endTime,
        formIds,
        draftIds,
        projects,
        buckets,
      } = params;
      const { data } = await axios.post('/forms/search', {
        projectId,
        customerId,
        vendorId,
        cardId,
        equipmentId,
        searchTerm,
        startTime,
        endTime,
        formIds,
        draftIds,
        projects,
        buckets,
      });
      return new Set(data ?? []);
    } catch (err) {
      return new Set();
    }
  }, 500)
);

export default function useFormSearch(params = {}) {
  const [searchSet, setSearchSet] = useState();
  const [searchLoading, setSearchLoading] = useState(false);
  useEffect(() => {
    const search = async () => {
      if (!params?.searchTerm) {
        setSearchLoading(false);
        setSearchSet();
      } else {
        setSearchLoading(true);
        setSearchSet(await searchForForms({
          ...params,
          onlyIDs: true,
        }));
        setSearchLoading(false);
      }
    };
    search();
  }, [params]);

  return { searchSet, searchLoading };
}
